const createFormData = (entries) => {
  const formData = new FormData();
  Object.entries(entries).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
};

const parseJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

const normalizeError = (message, status) => ({
  ok: false,
  message: message || "Request failed",
  status,
});

export const httpClient = {
  async get(url) {
    try {
      const response = await fetch(url, { method: "GET" });

      if (!response.ok) {
        return normalizeError(`HTTP error! status: ${response.status}`, response.status);
      }

      const data = await parseJsonSafely(response);
      return { ok: true, data };
    } catch (error) {
      return normalizeError(error.message || "Network error");
    }
  },

  async postForm(url, formEntries) {
    try {
      const response = await fetch(url, {
        method: "POST",
        body: createFormData(formEntries),
      });

      if (!response.ok) {
        return normalizeError(`HTTP error! status: ${response.status}`, response.status);
      }

      const data = await parseJsonSafely(response);
      return { ok: true, data };
    } catch (error) {
      return normalizeError(error.message || "Network error");
    }
  },
};
